import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-source-dimensions',
  templateUrl: './help-source-dimensions.component.html',
  styleUrls: ['./help-source-dimensions.component.scss']
})
export class HelpSourceDimensionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
